import { API } from '../configs/axios/axios.config'

const GET_USERS_ENDPOINT = '/users/'
const RESET_USER_OTP_ENDPOINT = '/users/reset-user-otp'

class _UsersService {
    getUsers() {
        return API.get(GET_USERS_ENDPOINT)
    }

    resetUserOtp(email) {
        return API.post(RESET_USER_OTP_ENDPOINT, null, { params: { email } })
    }
}

const UsersService = new _UsersService()
export default UsersService
